import { render, staticRenderFns } from "./base-view.vue?vue&type=template&id=259c0ebc&"
import script from "./base-view.vue?vue&type=script&lang=js&"
export * from "./base-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports